export { isBrowserUnsupported, isOldSafari } from './unsupported-browsers';
